import React from "react";
import { css } from "glamor";
import TipTapViewer from "../../library/TipTapViewer";
import { spacing } from "../../library/theme";

const wrapperClass = css({
  display: "flex",
  alignItems: "flex-start",
  gap: 10,
  marginBottom: spacing.m,
});

const bubbleAvatarClass = css({
  width: 28,
  height: 28,
  minWidth: 28,
  borderRadius: "50%",
  background: "#0369a1",
  color: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: 9,
});

const headerAvatarClass = css({
  width: 32,
  height: 32,
  minWidth: 32,
  borderRadius: "50%",
  background: "#0369a1",
  color: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: 10,
});

const bubbleClass = css({
  flex: 1,
  border: "0.66px solid #e0f2fe",
  borderRadius: 12,
  background: "#f0f9ff",
  padding: "11px 15px",
  display: "flex",
  flexDirection: "column",
  gap: 3,
});

const bubbleActiveClass = css({
  border: "1.5px solid #0369a1",
});

const nameClass = css({
  fontWeight: 600,
  color: "#0369a1",
  marginBottom: 0,
  fontSize: 10,
  lineHeight: "15px",
});

const observationsClass = css({
  color: "#64748b",
  fontSize: 10,
  lineHeight: "15px",
  marginBottom: spacing.xs,
});

const contentClass = css({
  fontSize: 13,
  lineHeight: "22px",
  color: "#1e293b",
});

const stepLabelClass = css({
  display: "flex",
  alignItems: "center",
  gap: 6,
  marginBottom: spacing.xs,
  paddingLeft: 38,
  color: "#94a3b8",
  fontSize: 10,
  fontWeight: 500,
  lineHeight: "15px",
});

const stepNumberClass = css({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 16,
  height: 16,
  borderRadius: "50%",
  background: "#f1f5f9",
  color: "#64748b",
  fontSize: 8,
  fontWeight: 700,
  lineHeight: "12px",
});

const senderHeaderClass = css({
  display: "flex",
  alignItems: "center",
  gap: 10,
  marginBottom: spacing.m,
});

const senderHeaderNameClass = css({
  fontWeight: 600,
  color: "#0f172a",
  fontSize: 12,
  lineHeight: "18px",
});

const shortName = (name = "Cliente") =>
  name
    .split(" ")
    .slice(0, 2)
    .map((word) => word[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

export default function PromptBubble({
  senderName = "Cliente",
  senderObservations,
  content,
  stepNumber,
  showSenderInfo = false,
  isActive = false,
}) {
  return (
    <>
      {showSenderInfo && (
        <div className={senderHeaderClass}>
          <div className={headerAvatarClass}>{shortName(senderName)}</div>
          <div>
            <div className={senderHeaderNameClass}>{senderName}</div>
            {senderObservations && (
              <div className={observationsClass}>{senderObservations}</div>
            )}
          </div>
        </div>
      )}

      {typeof stepNumber === "number" && (
        <div className={stepLabelClass}>
          <span className={stepNumberClass}>{stepNumber}</span>
          <span>Etapa {stepNumber}</span>
        </div>
      )}

      <div className={wrapperClass} data-testid="prompt-bubble">
        <div className={bubbleAvatarClass}>{shortName(senderName)}</div>
        <div className={css(bubbleClass, isActive && bubbleActiveClass)}>
          <div className={nameClass}>{senderName}</div>
          <TipTapViewer content={content} className={contentClass} />
        </div>
      </div>
    </>
  );
}
